export default __webpack_public_path__ + "0899f8b7f3b3b012dfc375acbf034664.png";